import React from 'react';

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { Tabs, Tab } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';

import { useMovie } from "../../movie/MovieProvider";
import { useMovieSetter } from "../../movie/MovieProvider";

export default function VEComponentPicker(props) {

    const movie = useMovie();
    const setMovie = useMovieSetter();

    const [openComponentPickerDialog, setOpenComponentPickerDialog] = React.useState(false);

    const element = props.element;
    const isTextElement = (element.type === "text"), isComponentElement = !isTextElement;
    let initialValue = (isComponentElement ? element.component : element.style) || "";
    const [tempComponentID, setTempComponentID] = React.useState(initialValue);
    const [activeTab, setActiveTab] = React.useState((isComponentElement ? "basic" : "text"));
    const tabsList = ["basic", "advanced"];
    const componentName = (isComponentElement ? element.component : `text/${element.style}`);

    const componentElementStrings = {
        dialogTitle: "Choose a component",
        textFieldLabel: "Type the component ID or choose one below"
    };
    const textElementStrings = {
        dialogTitle: "Choose a text style",
        textFieldLabel: "Type the text style ID or choose one below"
    };
    const literals = (isComponentElement ? componentElementStrings : textElementStrings);

    React.useEffect(() => {
        initialValue = (isComponentElement ? element.component : element.style) || "";
        setTempComponentID(initialValue);
        setActiveTab((isComponentElement ? "basic" : "text"));
    }, [openComponentPickerDialog]);

    return (
        <>
            <Stack className="mt-2 items-start" direction="column">
                {
                    (initialValue.length > 0) &&
                    <Box onClick={handleOpenComponentPickerDialog} className="w-32 rounded-lg cursor-pointer overflow-hidden">
                        <img src={`https://assets.json2video.com/assets/components/${componentName}-0.gif`} alt="Component thumbnail" className="block w-32 rounded-lg cursor-pointer" />
                    </Box>
                }
                <Box className="mt-3 w-full">
                    <Stack className="mb-2 -mt-4 items-end" direction="row">
                        <TextField onClick={handleOpenComponentPickerDialog} value={initialValue} fullWidth={true} disabled className="cursor-pointer" />
                        <IconButton onClick={handleOpenComponentPickerDialog}><EditIcon /></IconButton>
                    </Stack>
                    <p>{props.fieldDescription()}</p>
                </Box>

            </Stack>

            <Dialog open={openComponentPickerDialog} fullWidth={true} maxWidth="md" onClose={handleComponentPickerDialogClose} scroll="paper">
                <DialogTitle><span className="font-bold">{literals.dialogTitle}</span></DialogTitle>
                <DialogContent sx={{ paddingBottom: "0", overflowY: "hidden" }} dividers={true} className="overflow-hidden">
                    <Box className="flex items-end">
                        <TextField
                            fullWidth={true} label={literals.textFieldLabel}
                            type="text" 
                            value={tempComponentID}
                            onKeyDown={(event) => { if (event.keyCode === 13) submit(); }}
                            onChange={(event) => { setTempComponentID(event.target.value); }} />
                        <IconButton sx={{ marginLeft: "0.5rem" }} onClick={submit}><SearchIcon /></IconButton>
                    </Box>
                    {
                        (isComponentElement) &&
                        <Box className="mt-5">
                            <Tabs value={activeTab} onChange={onTabChange}>
                                {
                                    tabsList.map((tab, index) => {
                                        return (
                                            <Tab key={index} label={tab} value={tab} />
                                        );
                                    })
                                }
                            </Tabs>
                        </Box>
                    }
                    {ListComponentsInPack(activeTab)}
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleComponentPickerDialogClose}>Cancel</Button>
                    <Button variant="contained" onClick={submit}>Save</Button>
                </DialogActions>
            </Dialog>
        </>
    );

    function handleOpenComponentPickerDialog() {
        setOpenComponentPickerDialog(true);
    }

    function handleComponentPickerDialogClose() {
        setOpenComponentPickerDialog(false);
    }

    function submit(componentID = null) {
        if (!componentID) componentID = tempComponentID;
        else setTempComponentID(componentID);

        const [packName, componentIDNumber] = componentID.split("/");
        const example0Component = getExampleComponent(packName, componentIDNumber);

        console.log("Example component: ", example0Component);

        props.updateProperty(example0Component);
        handleComponentPickerDialogClose();
    }

    function onTabChange(event, value) {
        setActiveTab(value);
    }

    function ListComponentsInPack(packName) {

        const pack = props.componentsConfig[packName];
        const packComponents = pack.templates;

        let componentsList = {};
        Object.keys(pack.sections).map((section) => {
            componentsList[section] = [];
        });
        Object.keys(packComponents).sort().map((componentIDNumber, index) => {
            const component = packComponents[componentIDNumber];
            component.id = componentIDNumber;
            componentsList[component.section] = componentsList[component.section] || [];
            if (!component.hidden) componentsList[component.section].push(component);
        });

        return (
            <Box className="my-5 h-96 overflow-y-scroll">
                {
                    Object.keys(componentsList).map((section, index) => {
                        const sectionName = pack.sections[section];
                        const sectionComponents = componentsList[section];

                        if (sectionComponents.length === 0) return null;

                        return (
                            <Box key={index}>
                                <h3 className="text-xl font-bold">{sectionName}</h3>
                                <Box className="my-5 flex flex-wrap gap-2">
                                    {
                                        sectionComponents.map((component, index) => {
                                            let borderColor = "border-gray-300";
                                            if (element.component === `${packName}/${component.id}`) borderColor = "border-yellow-400";

                                            return (
                                                <Box key={index} id={packName + "/" + component.id} onClick={onComponentClick} className="cursor-pointer">
                                                    <img src={`https://assets.json2video.com/assets/components/${packName}/${component.id}-0.gif`} alt="thumbnail" className={`w-64 rounded-lg border-4 ${borderColor} hover:border-yellow-400`} />
                                                    <Box className="text-center w-64 overflow-ellipsis">{component.title} ({component.id})</Box>
                                                </Box>
                                            );
                                        })
                                    }
                                </Box>
                            </Box>
                        )
                    })
                }
            </Box>
        );
    }

    function onComponentClick(event) {
        console.log("Click on: ", event.currentTarget.id);
        submit(event.currentTarget.id);
    }

    function getExampleComponent(packName, componentIDNumber) {
        const example0 = props.componentsConfig[packName]?.templates[componentIDNumber]?.examples[0] ?? null;
        if (!example0) {
            if (isComponentElement) {
                return {
                    component: `${packName}/${componentIDNumber}`
                };
            }
            else if (isTextElement) {
                return {
                    style: `${componentIDNumber}`
                };
            }
        }

        const example0Title = props.componentsConfig[packName]?.templates[componentIDNumber]?.title ?? "";

        // go through the example and find the component that matches the componentIDNumber
        if (Array.isArray(example0.scenes)) {
            for (let s = 0; s < example0.scenes.length; s++) {
                const scene = example0.scenes[s];
                if (Array.isArray(scene.elements)) for (let e = 0; e < scene.elements.length; e++) {
                    const element = scene.elements[e];
                    if (isComponentElement && element.component === `${packName}/${componentIDNumber}`) return {
                        ...element,
                        comment: example0Title
                    };
                    else if (isTextElement && element.style === `${componentIDNumber}`) return {
                        ...element,
                        comment: example0Title
                    };
                }
            }
        }
        if (Array.isArray(example0.elements)) for (let e = 0; e < example0.elements.length; e++) {
            const element = example0.elements[e];
            if (isComponentElement && element.component === `${packName}/${componentIDNumber}`) return {
                ...element,
                comment: example0Title
            };
            else if (isTextElement && element.style === `${componentIDNumber}`) return {
                ...element,
                comment: example0Title
            };
        }

        if (isComponentElement) {
            return {
                comment: example0Title,
                component: `${packName}/${componentIDNumber}`
            };
        }
        else {
            return {
                comment: example0Title,
                style: `${componentIDNumber}`
            };
        }
    }
}